
import React from "react";
import ReactDOM from "react-dom";

import { Box, ThemeProvider, CssBaseline } from "@material-ui/core";

import theme from "./theme/theme";
import { observer } from "mobx-react-lite";
import VersionPopper from "./components/version";

const VersionApp = observer(() => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box width={1}>
        <VersionPopper />
      </Box>
    </ThemeProvider>
  )
})

const url = new URL(window.location.href);
let showVersion = false;
url.searchParams.forEach((_, param) => showVersion = showVersion || Boolean(/.*Version/.test(param)))
if (showVersion) {
  const versionElement = document.createElement("div");
  versionElement.id = "version";
  versionElement.style = "position:fixed;z-index:999999;bottom:0;left: 0;";
  document.body.appendChild(versionElement);

  ReactDOM.render(
    <VersionApp />,
    versionElement
  );
}